import React, { useState } from "react";
import { colors } from "../../styles/style";
import { style } from "./style";
import { MdAssignment, MdOutlinePendingActions } from "react-icons/md";
import { FaRoute, FaClipboardList } from "react-icons/fa";
import useListDashboardData from "../../hooks/useListDashboardData";
import useListSendedOrders from "../../hooks/useListSendedOrders";
import useListOrders from "../../hooks/useListOrders";
import { useEffect } from "react";

const initialStateOptions = [
  {
    option: "assign",
    text: "Asignación",
    color: colors.BLUE_COLOR,
  },
  {
    option: "pending",
    text: "Pendientes",
    color: colors.YELLOW_COLOR,
  },
  {
    option: "orders",
    text: "Seguimiento",
    color: colors.GREEN_COLOR,
  },
];

const ColumOptions = ({ onSelectOption }) => {
  //? hooks
  const { getUpdatedOrders } = useListDashboardData();
  const { getSendedOrders } = useListSendedOrders();
  const { getAllOrdersbyDate, allOrders } = useListOrders();

  const [options, setOptions] = useState([]);

  const [assignOrders, setAssignOrders] = useState(null);
  const [pendingOrders, setPendingOrders] = useState(null);
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    getNumbersOrders();
  });

  async function getNumbersOrders() {
    getUpdatedOrders()
      .then((orders) => {
        setAssignOrders(orders.length);
        //console.log("assignOrders: ", orders.length);
      })
      .catch((error) => {
        console.log("error [getUpdatedOrders] ", error);
      });

    getSendedOrders()
      .then((orders) => {
        setPendingOrders(orders.length);
        //console.log("pendingOrders: ", orders.length);
      })
      .catch((error) => {
        console.log("error [getSendedOrders] ", error);
      });

    getAllOrdersbyDate()
      .then(() => {
        if (!!allOrders) {
          setOrders(allOrders.length);
          //console.log("orders: ", allOrders.length);
        }
      })
      .catch((error) => {
        console.log("error [getAllOrdersbyDate] ", error);
      });

    setOptions(initialStateOptions);
  }

  const IconOption = ({ name }) => {
    switch (name) {
      case "assign":
        return <MdAssignment size={25} color={colors.GRAY_2_COLOR} />;
      case "pending":
        return (
          <MdOutlinePendingActions size={25} color={colors.GRAY_2_COLOR} />
        );
      case "orders":
        return <FaRoute size={25} color={colors.GRAY_2_COLOR} />;

      default:
        return <FaClipboardList size={25} color={colors.GRAY_2_COLOR} />;
    }
  };

  const numberOrders = (option) => {
    switch (option) {
      case "assign":
        return <h5>{assignOrders}</h5>;
      case "pending":
        return <h5>{pendingOrders}</h5>;
      case "orders":
        return <h5>{orders}</h5>;

      default:
        return <h5>--</h5>;
    }
  };

  return (
    <div className="col">
      {options.map((item, index) => {
        return (
          <div
            key={index}
            className="card"
            style={{ backgroundColor: item.color }}
          >
            <button
              className={"mb-3 rounded-3"}
              type="button"
              onClick={() => onSelectOption(item.option)}
              style={style.buttonOption}
            >
              <div
                className="card-img-top pt-2 justify-content-md-center container"
                style={{ backgroundColor: colors.WHITE_COLOR, height: 50 }}
              >
                <div className="row">
                  <div className="col">{numberOrders(item.option)}</div>
                  <div className="col">
                    <IconOption name={item.option} />
                  </div>
                </div>
              </div>
              <div
                className="card-body p-0 pt-2"
                style={{ backgroundColor: item.color }}
              >
                <h5 className="card-text" style={{ color: colors.WHITE_COLOR }}>
                  {item.text}
                </h5>
              </div>
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ColumOptions;
